module.exports = __webpack_public_path__ + "img/couples-041.44639aed.jpg";